import UsersPage from './UsersPage';
import { reducer } from './reducer';

export { reducer };
export default UsersPage;
